export const inputStyle = { input: { fontSize: "13px" } };

export const underLineStyle = {
  disableUnderline: true,
  style: { fontSize: "12px" },
};

export const flexStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignContent: "center",
};

export const FlexReverse = {
  display: "flex",
  flexDirection: "row-reverse",
};

export const buttonStyle = {
  display: "flex",
  mt: "20px",
  justifyContent: "end",
};

export const iconStyle = { fontSize: 30 };

export const errorStyle = {
  color: "#ff3d60",
  fontSize: "13px",
  fontWeight: "400",
  marginTop: "4px",
  marginLeft: "14px",
};

export const mouseCursor = { cursor: "pointer" };
